import { render, staticRenderFns } from "./HeaderStudentTaxInvoice.vue?vue&type=template&id=1e96ce0c&scoped=true"
import script from "./HeaderStudentTaxInvoice.vue?vue&type=script&lang=js"
export * from "./HeaderStudentTaxInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e96ce0c",
  null
  
)

export default component.exports